import { render, staticRenderFns } from "./MailTemplateEditDetails.vue?vue&type=template&id=3107e5fe&scoped=true&"
import script from "./MailTemplateEditDetails.vue?vue&type=script&lang=js&"
export * from "./MailTemplateEditDetails.vue?vue&type=script&lang=js&"
import style0 from "./MailTemplateEditDetails.vue?vue&type=style&index=0&id=3107e5fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3107e5fe",
  null
  
)

export default component.exports